import { render, staticRenderFns } from "./PosicionesMarcaciones.vue?vue&type=template&id=1c2d17ef&"
import script from "./PosicionesMarcaciones.vue?vue&type=script&lang=js&"
export * from "./PosicionesMarcaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports